<script>
  /** @type {{ shortUrl: string, copied?: boolean, onCopy?: () => void }} */
  let { shortUrl, copied = false, onCopy = undefined } = $props()

  let showQr = $state(false)

  // Simple QR code via Google Charts API (no dependency needed)
  const qrUrl = $derived(`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(shortUrl)}`)
</script>

<div class="share-card">
  <div class="share-url-row">
    <div class="share-url">{shortUrl}</div>
    <div class="share-actions">
      <button type="button" class="share-btn" onclick={() => onCopy?.()}>
        {#if copied}
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg>
          복사됨
        {:else}
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>
          복사
        {/if}
      </button>
      <button type="button" class="share-btn qr-btn" onclick={() => (showQr = !showQr)} title="QR 코드">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="3" width="7" height="7" rx="1" />
          <rect x="14" y="3" width="7" height="7" rx="1" />
          <rect x="3" y="14" width="7" height="7" rx="1" />
          <rect x="14" y="14" width="3" height="3" />
          <rect x="18" y="18" width="3" height="3" />
          <rect x="18" y="14" width="3" height="1" />
          <rect x="14" y="18" width="1" height="3" />
        </svg>
        QR
      </button>
    </div>
  </div>

  {#if showQr}
    <div class="qr-section">
      <img src={qrUrl} alt="QR Code" width="160" height="160" class="qr-image" />
      <p class="qr-hint">스마트폰 카메라로 스캔하세요</p>
    </div>
  {/if}
</div>

<style>
  .share-card {
    margin-top: 18px;
    padding: 16px;
    border-radius: var(--card-radius);
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    box-shadow: var(--card-shadow);
  }

  .share-url-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .share-url {
    flex: 1;
    color: var(--text-secondary);
    font-size: 13px;
    word-break: break-all;
    min-width: 0;
  }

  .share-actions {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
  }

  .share-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border: 1px solid var(--button-border, var(--card-border));
    background: var(--button-bg, var(--card-hover));
    color: var(--button-text, var(--text-primary));
    border-radius: 9999px;
    padding: 6px 12px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: all 150ms ease;
    font-family: inherit;
  }

  .share-btn:hover {
    opacity: 0.85;
  }

  .qr-section {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .qr-image {
    border-radius: 8px;
    border: 1px solid var(--card-border);
  }

  .qr-hint {
    font-size: 11px;
    color: var(--text-tertiary);
    margin: 0;
  }
</style>
